module.exports = __webpack_public_path__ + "img/message.b453b7b9.png";